<template>
  <div>
    <div
      v-for="(route, index) in routes"
      :key="index"
      class="stop-info"
    >

      <router-link
        :to="{
            name: 'routeinfo',
            params: {
                id: route.routeid,
            }
        }"
        class="stop-info-a"
      >

        <div class="stop-left-col">
          <div class="stop-left-top-row">
            <div class="routec">
              {{ route.routec }}
            </div>
            <div class="fare">
              ${{ route.fare }}
            </div>
          </div>
          <div class="route-meta">
            <div class="dir">
              {{ route.routedir === 1 ? route.destinc : route.startc }}
            </div>
          </div>
        </div>
        <div class="eta-wrap">
          <InlineEta :eta="route.eta ? stopEta(route.company, route.eta) : []"/>
        </div>

      </router-link>

    </div>
  </div>
</template>
<script>
import InlineEta from '../Eta/InlineEta';
import etaParse from "@/utils/etaParse";

export default {
  name: 'StopRouteList',
  props: ['routes'],
  components: {InlineEta},
  methods: {
    stopEta(company, eta) {
      if (eta) {
        return etaParse(company, eta);
      }

      return [];
    },
  },
}
</script>
<style scoped>
.stop-info {
  border-bottom: 1px solid grey;
  padding: 4px;
}

.stop-info-a {
  display: flex;
}

.stop-left-col {
  flex: 1 0 200px;
}

.eta-wrap {
  flex: 0 0 100px;
}

.routec, .fare {
  display: inline-block;
}

.routec {
  margin-right: 16px;
}
</style>
